/**
 * ForgotPasswordScreen — « Mot de passe oublié ? » (`reset-password`), sur le design system.
 *
 * Portage de `src/auth/ForgotPassword.js` : la page est contrôlée, tout vient de
 * `useForgotPasswordState` (l'adresse, sa validation, l'envoi, la suite et les sorties).
 */
import { ForgotPasswordPage } from "../../../../../../design-system"
import { AuthStatusBar } from "../AuthStatusBar"
import { useForgotPasswordState } from "./useForgotPasswordState"

export function ForgotPasswordScreen() {
    const page = useForgotPasswordState()
    return (
        <>
            <ForgotPasswordPage {...page} />
            <AuthStatusBar />
        </>
    )
}

export default ForgotPasswordScreen
